import {createUseStyles} from "react-jss";


export const useStyles = createUseStyles({
    item:{
        marginBottom: 8,
    }
})
